import { Button, Divider, MantineSize, Skeleton, Stack } from '@mantine/core'
import { IconBrandGoogleFilled, IconBrandWindows } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import { accountApi } from '@/api/accountApi'
import { OauthState } from './ssoUtils'

type SsoButtonsProps = {
  inviteToken?: string
  redirectTo?: string
  withDivider?: boolean
  marginTop?: MantineSize
}

export const SsoButtons = ({
  inviteToken,
  redirectTo,
  withDivider = true,
  marginTop
}: SsoButtonsProps) => {
  const { data: redirectUrl, isLoading } = useQuery({
    queryKey: ['accounts', 'sso', 'redirect-url'],
    queryFn: () => accountApi.getRedirectUrl(),
    retry: 1
  })

  const handleOauthRedirect = useCallback(
    (url: string) => {
      const redirectUrl = new URL(url)

      const state: OauthState = {
        redirectTo,
        token: inviteToken
      }

      redirectUrl.searchParams.set('state', JSON.stringify(state))
      window.location.href = redirectUrl.toString()
    },
    [redirectTo, inviteToken]
  )

  if (isLoading) {
    return (
      <Stack gap="md" mt={marginTop}>
        <Skeleton height={20} />
        <Skeleton height={20} />
      </Stack>
    )
  }

  if (redirectUrl) {
    return (
      <Stack gap="md" mt={marginTop}>
        {withDivider && (
          <Divider label={<FormattedMessage id="auth.sso.orContinueWith" />} />
        )}

        <Button
          type="button"
          variant="outline"
          leftSection={
            <IconBrandGoogleFilled
              size={20}
              color="var(--mantine-color-gray-6)"
            />
          }
          fullWidth
          onClick={() => handleOauthRedirect(redirectUrl.google)}
        >
          Google
        </Button>

        <Button
          type="button"
          variant="outline"
          leftSection={
            <IconBrandWindows size={20} color="var(--mantine-color-blue-6)" />
          }
          fullWidth
          onClick={() => handleOauthRedirect(redirectUrl.microsoft)}
        >
          Microsoft
        </Button>
      </Stack>
    )
  }

  return null
}
